import { observable, action } from 'mobx'
import { message, Modal } from 'hljd'
import React from 'react'
import Api from '@api/xiu_yan/homeApi'
import { getMerchantInfo, logout } from '@util'

class Store {
  @observable oneSubStoreVisible = false
  @observable moreSubStoreVisible = false
  @observable name = ''
  @action
  checkVisible = () => {
    const { unbind_data = {}, name } = getMerchantInfo()
    const { is_only_one, should_unbind } = unbind_data

    this.name = name

    if (should_unbind && is_only_one) {
      this.oneSubStoreVisible = true
      this.startCountdown()
    }

    if (should_unbind && !is_only_one) {
      this.moreSubStoreVisible = true
    }
  }

  @action
  submit = async values => {
    const { success, msg } = await Api.unbindParent({
      phone: values.contact_phone,
      sms_code: values.code,
      password: values.password
    })

    if (success) {
      this.moreSubStoreVisible = false
      Modal.success({
        title: '解绑成功',
        content: (
          <p>
            将在<span style={{ color: 'red' }}>5S</span>后返回登录页
          </p>
        ),
        onOk: () => {
          setTimeout(() => {
            logout()
          }, 5000)
        }
      })

      setTimeout(() => {
        logout()
      }, 5000)
    } else {
      message.warning(msg)
    }
  }

  @observable interval = null
  @observable count = 3
  @observable canLogout = true
  @action
  startCountdown = () => {
    this.interval = setInterval(() => {
      this.count--

      if (this.count < 1) {
        this.canLogout = false
        window.clearInterval(this.interval)
        this.interval = null
      }
    }, 1000)
  }

  @action
  reLogin = async () => {
    let { success } = await Api.threeRoleUnbindParent()
    if (success) {
      logout()
    }
  }
}
export default Store
